import React, { useEffect, useState } from 'react';
import Link from './Link';
import axios from 'axios';
import { SignOutButton } from "../SSO/SignOutButton";
import { SignInButton } from "../SSO/SignInButton";
import { useIsAuthenticated } from "@azure/msal-react";




const Sidebar = () => {
  const [navigation, setNavigation] = useState([]);
  const isAuthenticated = useIsAuthenticated();
  const fetchData = () => {
    axios.get("getNavigation").then((response) => {
      setNavigation(response.data.data)
    })
  }
  useEffect(() => {
    // fetchData()
  }, [])
  const logout = () => {
    localStorage.removeItem('token');
    window.location.reload(true);
  }
  const toggle = () => {
    // var btn = document.getElementById("header-btn");
    var sidebar = document.getElementById("sidebar");
    var main = document.getElementsByClassName("main");
    if (document.body.contains(sidebar) && main && sidebar.classList.contains("collapse-nav")) {
      sidebar.classList.remove("collapse-nav");

      // main.classList.remove("collapse-nav");
      for (var i = 0; i < main.length; i++) {
        main[i].classList.remove("collapse-nav")
      }
    } else {
      sidebar.classList.add("collapse-nav");
      for (var i = 0; i < main.length; i++) {
        main[i].classList.add("collapse-nav")
      }
    }
  };
  return (
    <>

      <aside id="sidebar" className="sidebar rounded-1 py-3 shadowd">

        <div className="d-flex align-items-center justify-content-between mb-4 mt-2 px-3 ">
          <a href="index.html" className="logo d-flex align-items-center">
            <img src="assets/images/logos/clogo.png" alt="" width="160" height="100" />

          </a>
          <i class="fa-solid fa-xmark toggle-sidebar-btn fa-2xl bx-x" onClick={() => toggle()}></i>
        </div>
        <ul className="sidebar-nav pt-3" id="sidebar-nav">
          <>
            <Link path={"/"} icon={"fa-solid fa-home text-light"} label={"Home"} sublinks={[]} />
            <Link path={"/people-management"} icon={"fa-solid fa-users text-light"} label={"People Management"} sublinks={[
              {
                url: "/culture",
                label: "Culture"
              },
              {
                url: "/engage",
                label: "Engage"
              },
              {
                url: "/learn",
                label: "Learn"
              },
              {
                url: "/grow",
                label: "Grow"
              },
              {
                url: "/reward",
                label: "Reward"
              }

            ]} />

            <Link path={"/reports"} icon={"fa-solid fa-chart-pie text-light"} label={"Reports"} sublinks={[
              {
                url: "https://demo-reports.concisesolutions.co.za/",
                label: "People Analytics",
                openNewTab:true,
              }
            ]} />

            <Link clickableLink path={"/system-links"} icon={"fa-solid fa-users text-light"} label={"System Links"} sublinks={[
              {
                url: "https://demo-recognition.concisesolutions.co.za/",
                label: "Employee Recognition",
                openNewTab:true,
              },
              {
                url: "https://uat-wellbeing.concisesolutions.co.za/",
                label: "Employee Wellness",
                openNewTab:true,
              },
              {
                url: "https://demo-issue-log.concisesolutions.co.za/",
                label: "Issue Logging resolution",
                openNewTab:true,
              },
              {
                url: "https://demo-engagement.concisesolutions.co.za/",
                label: "Engagement Surveys",
                openNewTab:true,
              },

              {
                url: "/recruitment-onboarding",
                label: "Recruitment Onboarding",
                openNewTab:true,
              },
              {
                url: "https://demo-new-hire.concisesolutions.co.za/",
                label: "New Hire Surveys",
                openNewTab:true,
              },
              {
                url: "https://demo-exit.concisesolutions.co.za/",
                label: "Exit Interviews",
                openNewTab:true,

              },
              {
                url: "/lms",
                label: "LMS",
                openNewTab:true,

              },
              {
                url: "/work-architecture-job-benchmark",
                label: "Work Architecture & Job Benchmarking",
                openNewTab:true,
              },
              {
                url: "https://demo-wpsatr.concisesolutions.co.za/",
                label: "WSP / ATR Reporting",
                openNewTab:true,
              },
              {
                url: "https://demo-performance.concisesolutions.co.za/",
                label: "Performance Management",
                openNewTab:true,
              },
              {
                url: "https://demo-talent.concisesolutions.co.za/",
                label: "Talent Management",
                openNewTab:true,
              },
              {
                url: "https://demo-remsys.concisesolutions.co.za/",
                label: "Increase & Bonus Allocation",
                openNewTab:true,
              },
              {
                url: "/incentive-scheme-contracting",
                label: "Incentive Scheme Contracting",
                openNewTab:true,
              },

            ]} />

            <Link path={"/issue-logs"} icon={"fa-solid fa-info text-light"} label={"Issue Logs"} sublinks={[]} />
            <Link path={"/document-resources"} icon={"fa-regular fa-folder-open text-light"} label={"Document & Resources"} sublinks={[]} />
            <Link path={"/help-support"} icon={"fa-solid fa-info text-light"} label={"Help & Support"} sublinks={[]} />

            <li className="nav-item">
              {isAuthenticated ? <SignOutButton show={true}/> :
                  <a className="nav-link main-link" onClick={() => { logout()  }}>
                    <span className="icon-shape icon ps-1">
                      <i className="fa-solid fa-right-from-bracket"></i>
                   </span>
                    <span className='ms-2 link-label text-dark d-flex w-100'> Signout</span>
                  </a>
              }
            </li>
          </>
        </ul>
      </aside>

    </>
  )
}
export default Sidebar;